import { SvgIcon, createSvgIcon } from "@mui/material";

const RestQuarterIcon = createSvgIcon(
  <SvgIcon viewBox="0 0 6.5 18.71">
    <path d="M6,14.74c.77.33.68,1.7-.28,1-.72-.89-2.09-1.66-3.08-.69A1.73,1.73,0,0,0,3,17.79c.65.13,1.15,1.24.08.83C1.53,18.09-.12,16.76,0,15a2.08,2.08,0,0,1,2.35-1.89c.45-.16,1.69.48,1.63.2C3.23,12.12,2.37,11,1.7,9.82c-.24-.73.28-1.42.5-2.1.48-1.2,1-2.37,1.45-3.59,0-.75-.62-1.28-1-1.89A13.85,13.85,0,0,1,1.48.36c0-.88.93.1,1.17.46C3.73,2.09,4.86,3.32,5.9,4.63c.69.84,0,1.83-.29,2.67a39.22,39.22,0,0,0-1.5,3.77c0,1.07.74,2,1.24,2.85A8.7,8.7,0,0,0,6,14.74Z"/>
  </SvgIcon>
);

export default RestQuarterIcon;
